<!-- AccessibilityStatement.vue - Erklärung zur Barrierefreiheit in the article layout. -->
<template>
  <ArticleLayout :eyebrow="$t('legal.eyebrow')" :title="$t('legal.a11y.title')" :sections="sections">
    <section id="goal">
      <h2>{{ $t('legal.a11y.goalTitle') }}</h2>
      <p>{{ $t('legal.a11y.goalText') }}</p>
    </section>
    <section id="status">
      <h2>{{ $t('legal.a11y.statusTitle') }}</h2>
      <p>{{ $t('legal.a11y.statusText') }}</p>
    </section>
    <section id="limits">
      <h2>{{ $t('legal.a11y.limitsTitle') }}</h2>
      <ul>
        <li>{{ $t('legal.a11y.limitMap') }}</li>
        <li>{{ $t('legal.a11y.limitLanguage') }}</li>
        <li>{{ $t('legal.a11y.limitPhotos') }}</li>
      </ul>
    </section>
    <section id="barrier">
      <h2>{{ $t('legal.a11y.barrierTitle') }}</h2>
      <p v-if="contact">{{ $t('legal.a11y.barrierText') }} <a :href="'mailto:' + contact">{{ contact }}</a>.</p>
      <p v-else class="todo">{{ $t('legal.a11y.barrierTodo') }}</p>
    </section>
    <section v-if="operator" id="operator">
      <h2>{{ $t('legal.a11y.operatorTitle') }}</h2>
      <p>{{ operator }}</p>
    </section>
    <p class="fineprint">{{ $t('legal.a11y.fineprint') }}</p>
  </ArticleLayout>
</template>

<script>
import ArticleLayout from '@/components/ArticleLayout.vue';

export default {
  name: 'AccessibilityStatement',
  components: { ArticleLayout },
  data() {
    return {
      contact: process.env.VUE_APP_A11Y_CONTACT || '',
      operator: process.env.VUE_APP_OPERATOR_NAME || '',
    };
  },
  computed: {
    sections() {
      const s = ['goal', 'status', 'limits', 'barrier'].map((id) => ({ id, title: this.$t(`legal.a11y.${id}Title`) }));
      if (this.operator) s.push({ id: 'operator', title: this.$t('legal.a11y.operatorTitle') });
      return s;
    },
  },
};
</script>

<style scoped>
.todo { font-style: italic; }
.fineprint { font-size: 14px !important; color: var(--color-secondary); }
</style>
